export default __webpack_public_path__ + "caca510753ff1bef897dbe05ad689f38.png";